export enum FlowModeEnum {
  CREATE = 'create',
  EDIT = 'edit',
  OUTFIT = 'outfit',
  PROFILE = 'profile',
}
